<div class="mb-2">
  <h1 class="main-title">Mantenedores > Usuarios > {{editMode ? "Editar": "Ver"}} Usuario</h1>
  <div class="flex justify-end items-center mb-2">
    <a routerLink="/user-management" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>
</div>



<div class="single-page-content">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label for="fullName" class="block text-sm font-bold mb-2">Nombre<span class="text-danger-500">*</span>:</label>
        <input id="fullName" type="text" formControlName="fullName" class="input" placeholder="Nombre">
        <div *ngIf="userForm.get('fullName')?.invalid && (userForm.get('fullName')?.dirty || userForm.get('fullName')?.touched)" class="text-danger-500 text-sm">
          El nombre es obligatorio.
        </div>
      </div>

      <div class="mb-4">
        <label for="email" class="block text-sm font-bold mb-2">email<span class="text-danger-500">*</span>:</label>
        <input id="email" type="text" formControlName="email" class="input" placeholder="email">
        <div *ngIf="userForm.get('email')?.invalid && (userForm.get('email')?.dirty || userForm.get('email')?.touched)" class="text-danger-500 text-sm">
          El email es obligatorio.
        </div>
      </div>

      <div class="mb-4">
        <label for="area" class="block text-sm font-bold mb-2">Area<span class="text-danger-500">*</span>:</label>
        <select id="area" formControlName="area" class="input" > 
          <option value="" disabled>Seleccione area</option>
          <option *ngFor="let item of areas" [value]="item.id">{{ item.name }}</option>
        </select>
        <div *ngIf="userForm.get('area')?.invalid && (userForm.get('area')?.dirty || userForm.get('area')?.touched)" class="text-danger-500 text-sm">
          Debe seleccionar un área
        </div>
      </div>

      <div class="mb-4">
        <label for="state" class="block text-sm font-bold mb-2">Estado<span class="text-danger-500">*</span>:</label>
        <select  id="state" formControlName="state" class="input">
          <option value="" disabled>Seleccione Estado</option>
          <option *ngFor="let item of states" [value]="item.id">{{ item.name }}</option>
        </select>
        <div *ngIf="userForm.get('state')?.invalid && (userForm.get('state')?.dirty || userForm.get('state')?.touched)" class="text-danger-500 text-sm">
          Debe seleccionar un estado
        </div>
      </div>
       
      <div *ngIf="errorMessage" class="mb-4 text-danger-500">
        {{ errorMessage }}
      </div>
   
      @if(editMode){
        <div class="flex items-center justify-end">
        <button type="submit" class="button button-success">
          Guardar cambios
        </button>
      </div>
      }
        
    </form>
  </div>